export default "__VITE_ASSET__ifkyu$ss__"